import { LoanOfferStatus } from '../../../interfaces';
import LoanOfferStatusBadge from '../../Common/LoanOfferStatusBadge';
import { useSelector } from 'react-redux';
import { RootState } from '../../../states/reducers';
import { dateFormat } from '../../../helpers';
import EditLoanOffer from './EditLoanOffer';
import CancelLoanOffer from './CancelLoanOffer';

export const InvestorLoanOffers = () => {
  const { loanOffers } = useSelector((state: RootState) => state.loanOffer);

  const { auth } = useSelector((state: RootState) => state);
  const userId = auth.authUser?.user.id;

  return (
    <>
      {loanOffers && loanOffers.length > 0 ? (
        <div className='table-responsive'>
          <table className='table align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bolder text-muted border-tr'>
                <th className='ps-4 min-w-255px rounded-start'>Investor Name</th>
                <th className='min-w-100px'>Tenure</th>
                <th className='min-w-100px'>Interest</th>
                <th className='min-w-70px'>Status</th>
                <th className='min-w-50px'>Date</th>
                <th className='text-end rounded-end'></th>
              </tr>
            </thead>
            <tbody>
              {loanOffers.map((offer) => (
                <tr key={offer.id}>
                  <td>
                    <div className='d-flex align-items-center'>
                      <div className='d-flex justify-content-start flex-column'>
                        <div className='text-dark fw-bold text-hover-primary mb-1 fs-7 text-capitalize'>{`${offer.user.firstname} ${offer.user.lastname}`}</div>
                      </div>
                    </div>
                  </td>
                  <td className='align-top'>
                    <span className='text-dark fw-bold text-hover-primary d-block mb-1 fs-7'>{`${offer.tenure} months`}</span>
                  </td>
                  <td className='align-top'>
                    <span className='text-dark fw-bold text-hover-primary d-block mb-1 fs-7'>{`${parseFloat(offer.interest)}%`}</span>
                  </td>
                  <td className='align-top'>
                    <LoanOfferStatusBadge status={offer.status} />
                  </td>
                  <td className='align-top'>
                    <span className='text-dark fw-bold d-block mb-1 fs-7'>{dateFormat(offer.updated_at)}</span>
                  </td>
                  {+userId! === offer.user_id && offer.status !== LoanOfferStatus.CANCELLED && offer.status !== LoanOfferStatus.ACCEPTED && (
                    <td className='text-end align-top'>
                      <EditLoanOffer loanOffer={offer} />
                      <CancelLoanOffer loanOffer={offer} />
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div>
          <div className='d-flex justify-content-center align-item-center'>
            <div className='text-center pt-20 pb-20'>
              <i className='bi bi-folder' style={{ fontSize: '3.5em' }}></i>
              <p className='text-muted ms-20p me-20p pt-3 pb-3'>There are no offers at the moment</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
